import { WidgetType } from './home-dashboard.models';

export interface DashboardWidgetTheme {
  accentColor?: string;
  chartScheme?: string;
  customColors?: Array<{ name: string; value: string }>;
}

export const HOME_DASHBOARD_THEME = {
  dashboardBackground: '#eaf4ff',
  cardBackground: '#f4f4ef',
  cardText: '#1c2b39',
  cardMutedText: '#6e7b86',
  sectionTitle: '#15293d',
  typeThemes: {} as Partial<Record<WidgetType, DashboardWidgetTheme>>
};